var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (email, figureid, id, link, public_name, t, timezone, timezones, undefined) {
buf.push("<div class=\"main-wrapper\"><header>");
if ( figureid)
{
buf.push("<figure" + (jade.attr("id", id, true, true)) + ">");
if ( link)
{
buf.push("<a" + (jade.attr("href", link, true, true)) + " target=\"_blank\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></a>");
}
else
{
buf.push("<div class=\"svg-wrapper\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></div>");
}
buf.push("</figure>");
}
buf.push("<h1>" + (jade.escape(null == (jade_interp = t('step infos title')) ? "" : jade_interp)) + "</h1></header><div role=\"region\"><form id=\"infos-form\"><p>" + (jade.escape(null == (jade_interp = t('step infos description')) ? "" : jade_interp)) + "</p><p class=\"line\"><label for=\"public_name\">" + (jade.escape(null == (jade_interp = t('step infos public_name label')) ? "" : jade_interp)) + "</label><input type=\"text\" name=\"public_name\" id=\"public_name\"" + (jade.attr("value", public_name, true, true)) + (jade.attr("placeholder", t("step infos public_name placeholder"), true, true)) + "><p data-for=\"public_name\" class=\"error-label\"></p></p><p class=\"line\"><label for=\"email\">" + (jade.escape(null == (jade_interp = t('step infos email label')) ? "" : jade_interp)) + "</label><input type=\"text\" name=\"email\" id=\"email\"" + (jade.attr("value", email, true, true)) + (jade.attr("placeholder", t("step infos email placeholder"), true, true)) + "><p data-for=\"email\" class=\"error-label\"></p></p><p class=\"line\"><label for=\"timezone\">" + (jade.escape(null == (jade_interp = t('step infos timezone label')) ? "" : jade_interp)) + "</label><select type=\"text\" name=\"timezone\" id=\"timezone\">");
// iterate timezones
;(function(){
  var $$obj = timezones;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var label = $$obj[$index];

if ((label === timezone))
{
buf.push("<option" + (jade.attr("value", label, true, true)) + " selected=\"selected\">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</option>");
}
else
{
buf.push("<option" + (jade.attr("value", label, true, true)) + ">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</option>");
}
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var label = $$obj[$index];

if ((label === timezone))
{
buf.push("<option" + (jade.attr("value", label, true, true)) + " selected=\"selected\">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</option>");
}
else
{
buf.push("<option" + (jade.attr("value", label, true, true)) + ">" + (jade.escape(null == (jade_interp = label) ? "" : jade_interp)) + "</option>");
}
    }

  }
}).call(this);

buf.push("</select><p data-for=\"timezone\" class=\"error-label\"></p></p><p class=\"errors\"></p></form></div><footer><div class=\"controls\"><button form=\"infos-form\" class=\"next\">" + (jade.escape(null == (jade_interp = t('step infos submit')) ? "" : jade_interp)) + "</button><div class=\"progression\"></div></div><div class=\"progression\"></div></footer></div>");}.call(this,"email" in locals_for_with?locals_for_with.email:typeof email!=="undefined"?email:undefined,"figureid" in locals_for_with?locals_for_with.figureid:typeof figureid!=="undefined"?figureid:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"link" in locals_for_with?locals_for_with.link:typeof link!=="undefined"?link:undefined,"public_name" in locals_for_with?locals_for_with.public_name:typeof public_name!=="undefined"?public_name:undefined,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined,"timezone" in locals_for_with?locals_for_with.timezone:typeof timezone!=="undefined"?timezone:undefined,"timezones" in locals_for_with?locals_for_with.timezones:typeof timezones!=="undefined"?timezones:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/views/templates/view_steps_infos.jade
// module id = 23
// module chunks = 0